/**
 * Feature keys the BeamXR Live app is known to honour, offered as suggestions on the promotion
 * form. Suggestions only: any key can be typed, so a key added to a new app build can be scheduled
 * without changing the portal. Builds that don't know a key simply ignore it.
 */
export interface KnownFeatureKey {
  key: string;
  name: string;
  description: string;
}

export const FEATURE_KEY_PATTERN = /^[a-z0-9_.-]{1,64}$/;

export const KNOWN_FEATURE_KEYS: KnownFeatureKey[] = [
  {
    key: "high_quality_streaming",
    name: "High quality streaming",
    description:
      "Unlocks the High and Custom bitrate presets and 60 FPS for users without Pro. A stream " +
      "already live when the window ends keeps its quality; the next stream reverts to Standard/30 FPS.",
  },
  {
    key: "subscription_referrals",
    name: "Subscription referrals",
    description:
      "A switch rather than a free feature: while live, Meta Store subscribers see the referral card " +
      "on the Pro page and a one-off announcement. Only turn on once referrals are enabled for every " +
      "subscription SKU in the Meta Developer Dashboard. Usually given an end date far in the future.",
  },
];

export function findKnownFeatureKey(key: string): KnownFeatureKey | undefined {
  return KNOWN_FEATURE_KEYS.find((k) => k.key === key);
}
